import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { switchMap } from 'rxjs/operators';
import { AuthenticationService } from '../authentication/authentication.service';
import { User } from 'oidc-client-ts';
import { KeycloakService } from 'keycloak-angular';
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  private authenticationService: AuthenticationService;
  private keycloak: KeycloakService;

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authenticationService === undefined) {
      this.authenticationService = this.injector.get(AuthenticationService);
    }
    if (this.keycloak === undefined) {
      this.keycloak = this.injector.get(KeycloakService);
    }
    let language = localStorage.getItem('language');
    if (!language) {
      language = 'en-ca';
    }
    if (this.authenticationService.checkIsSSOLogin()) {
      let token = this.authenticationService.getSSOToken();
      if (this.authenticationService.checkIsROPLogin()) {
        return next.handle(
          req.clone({
            setHeaders: {
              Authorization: 'Bearer ' + token,
              'Accept-Language': language,
            },
          })
        );
      } else {
        return next.handle(
          req.clone({
            setHeaders: {
              Authorization: 'Bearer ' + token,
              'Accept-Language': language,
              'App-Version': environment.appVersion,
            },
          })
        );
      }
    } else {
      return this.authenticationService.getCurrentUserToken().pipe(
        switchMap((token: string) => {
          return next.handle(
            req.clone({
              setHeaders: {
                Authorization: 'Bearer ' + token,
                'Accept-Language': language,
                'App-Version': environment.appVersion,
              },
            })
          );
        })
      );
    }
  }
}
